import ApiCaller from '../ApiCaller';
import baseAjaxConfig from '../BaseAjaxConfig';
export var CITY_AUTO_SUGGESTION;
(function (CITY_AUTO_SUGGESTION) {
    CITY_AUTO_SUGGESTION["REQUEST"] = "CITY_AUTO_SUGGESTION_REQUEST";
    CITY_AUTO_SUGGESTION["SUCCESS"] = "CITY_AUTO_SUGGESTION_SUCCESS";
    CITY_AUTO_SUGGESTION["ERROR"] = "CITY_AUTO_SUGGESTION_ERROR";
    CITY_AUTO_SUGGESTION["RESET"] = "CITY_AUTO_SUGGESTION_RESET";
})(CITY_AUTO_SUGGESTION || (CITY_AUTO_SUGGESTION = {}));
export function resetSuggestionAction(id) {
    return (dispatch) => dispatch({
        type: CITY_AUTO_SUGGESTION.RESET,
        id
    });
}
/**
 * This is called on every focus of text input and on change of text input value.
 * TODO: implement cache logic.
 * @param text input text value
 * @param id is used to separate suggestions data of depart city and arrival city.
 */
export function fetchSuggestionAction(text, id) {
    return (dispatch, _getState) => {
        dispatch({
            type: CITY_AUTO_SUGGESTION.REQUEST,
            id
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: `/api/2/flights/auto-suggest?query=${text || ''}`,
            action: CITY_AUTO_SUGGESTION.REQUEST
        }))
            .then((json) => dispatch({
            type: CITY_AUTO_SUGGESTION.SUCCESS,
            data: json['RESPONSE'],
            id
        }))
            .catch(error => {
            return dispatch({
                type: CITY_AUTO_SUGGESTION.ERROR,
                error,
                id
            });
        });
    };
}
